const DISMISS_KEY = 'testera_pwa_install_dismissed_at';
const DISMISS_MS = 7 * 24 * 60 * 60 * 1000;

export function isStandaloneDisplay() {
  try {
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
      return true;
    }
    // iOS / iPadOS legacy
    if (typeof navigator !== 'undefined' && navigator.standalone === true) {
      return true;
    }
  } catch {
    // ignore
  }
  return false;
}

export function getInstallPlatform() {
  if (typeof navigator === 'undefined') {
    return { isMac: false, isIOS: false, isSafari: false, isChromium: false };
  }
  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua)
    || (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isMac = !isIOS && (/Macintosh|Mac OS X/.test(ua) || platform.startsWith('Mac'));
  const isChromium = /Chrome|Chromium|Edg|OPR|Brave/i.test(ua);
  // Safari on macOS/iOS reports Safari but not Chrome/Chromium tokens.
  const isSafari = /Safari/i.test(ua) && !isChromium;
  return { isMac, isIOS, isSafari, isChromium };
}

export function wasInstallDismissedRecently(now = Date.now()) {
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    if (!raw) return false;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) return false;
    return now - ts < DISMISS_MS;
  } catch {
    return false;
  }
}

export function dismissInstallPrompt(now = Date.now()) {
  try {
    localStorage.setItem(DISMISS_KEY, String(now));
  } catch {
    // ignore
  }
}

export function clearInstallDismiss() {
  try {
    localStorage.removeItem(DISMISS_KEY);
  } catch {
    // ignore
  }
}

/** Human copy for browsers without beforeinstallprompt (Safari / Mac). */
export function getManualInstallSteps(platform = getInstallPlatform()) {
  if (platform.isIOS) {
    return {
      title: 'Add Testera to your Home Screen',
      steps: [
        'Tap the Share button in Safari',
        'Scroll and tap “Add to Home Screen”',
        'Confirm “Add” — Testera opens like an app',
      ],
    };
  }
  if (platform.isMac && platform.isSafari) {
    return {
      title: 'Add Testera to your Dock',
      steps: [
        'In Safari, open File → Add to Dock…',
        'Or use the share sheet → Add to Dock',
        'Launch Testera from the Dock in its own window',
      ],
    };
  }
  if (platform.isMac) {
    return {
      title: 'Install Testera on your Mac',
      steps: [
        'In Chrome/Edge, open the install icon in the address bar',
        'Or use the “Install Testera” button when it appears',
        'Prefer Safari? File → Add to Dock…',
      ],
    };
  }
  return {
    title: 'Install Testera',
    steps: [
      'Use your browser’s install / “Add to Home Screen” action',
      'Or click “Install Testera” when the prompt appears',
      'Open the installed app for a focused, offline-friendly shell',
    ],
  };
}
